import * as Yup from "yup";

const validationSchema = Yup.object().shape({
  exerciseSets: Yup.array().of(
    Yup.object().shape({
      sets: Yup.number()
        .min(1, "Sets should be more than 0")
        .max(99, "Sets should be less than 100")
        .required("Sets is required"),
      reps: Yup.number()
        .min(1, "Reps should be more than 0")
        .max(99, "Reps should be less than 100")
        .required("Reps is required"),
      weight: Yup.number()
        .min(0, "Weight should be more than 0")
        .max(999, "Weight should be less than 1000")
        .required("Weight is required")
    })
  )
});

export default validationSchema;
